
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { ElMessage } from 'element-plus';
import router from '@/router';
export class Request {
    public static axiosInstance: AxiosInstance;

    public static init() {
        // 创建axios实例
        this.axiosInstance = axios.create({
            baseURL: process.env.VUE_APP_BASE_URL,
            timeout: 100000,
            method: 'POST'
        });
        // 初始化拦截器
        this.initInterceptors();
    }

    // 为了让http.ts中获取初始化好的axios实例
    // public getInterceptors() {
    //     return this.axiosInstance;
    // }

    // 初始化拦截器
    public static initInterceptors() {
        // 设置post请求头
        this.axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
        /**
         * 请求拦截器
         * 每次请求前，如果存在token则在请求头中携带token
         */
        this.axiosInstance.interceptors.request.use(
            (config: AxiosRequestConfig) => {
                // console.log(config)
                // if (config.headers.isJwt) {
                var token = localStorage.getItem('ACCESS_TOKEN');
                if (token) {
                    //token = 'XAJO0P8b241WfH7ppYzhpra86Jll1pEqYAxeREOPPSyeAXH9D1IVcIfeGA2O+TrlVmGEM4RB4bWG2WksWywQ3cgGR1pCEQ8DUhy75jaELVQ='
					config.data = {...config.data, token}
				   	// this.axiosInstance.defaults.headers.common['token'] = token;
     //                config.headers.Authorization = token;
					
					
                }
			
                return config;
            },
            (error: any) => {
                console.log(error);
            },
        );


        // 响应拦截器
        this.axiosInstance.interceptors.response.use(
            // 请求成功
            (response: AxiosResponse) => {

                if (response.status === 200) {
                    switch (response.data.status) {
                        case 202:
                            ElMessage.success(response.data.message)
                            break
                        case 300:
							localStorage.removeItem('ACCESS_TOKEN')
                            ElMessage.warning(response.data.message)
							router.push('/login')
                            break
                        case 404:
                            ElMessage.error(response.data.message)
                            break
                    }
                    return response.data;
                } else {
                    Request.errorHandle(response);
                    return response;
                }
            },
            // 请求失败
            (error: any) => {
                const { response } = error;
                if (response) {
                    // 请求已发出，但是不在2xx的范围
                    Request.errorHandle(response);
                    return Promise.reject(response.data);
                } else {
                    // 处理断网的情况
                    // eg:请求超时或断网时，更新state的network状态
                    // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
                    // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
                    ElMessage.warning('网络连接异常,请稍后再试!');
                }
            }
        );
    }

    /**
     * http握手错误
     * @param res 响应回调,根据不同响应进行不同操作
     */
    private static errorHandle(res: any) {
        console.log(res)
        // 状态码判断
        switch (res.status) {
            // case 401:
            //     break;
            // case 403:
            //     break;
            case 404:
                ElMessage.warning('请求的资源不存在');
                break;
            default:
                ElMessage.warning('连接错误');
        }
    }

}
